module.exports = __webpack_public_path__ + "img/circles-on-circle.3ee3d409.svg";